import { animate, state, style, transition, trigger } from '@angular/animations'
import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { OrderWizardService } from '../_service/order-wizard.service'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { OrderWizardPurchaseComponent } from '../step-01/purchase/order-wizard-purchase.component'
import { OrderWizardDueDiligenceComponent } from '../step-04/due-diligence/order-wizard-due-diligence.component'
import { OrderWizardPickupPointComponent } from '../step-02/pickup-point/order-wizard-pickup-point.component'
import { OrderWizardFooterComponent } from './footer/order-wizard-footer.component'
import { OrderWizardIdentificationComponent } from '../step-03/itsme-login/order-wizard-identification.component'
import { OrderWizardSummaryComponent } from '../step-06/summary/order-wizard-summary.component'
import { OrderWizardTermAndConditionComponent } from '../step-05/order-wizard-term-and-condition.component'
import { OrderWizardHeaderComponent } from './header/order-wizard-header.component'
import { OrderWizardNavigationService } from '../_service/order-wizard-navigation.service'
import { OrderPaymentSuccessComponent } from './payment-result/success/payment-success.component'

@Component({
    selector: 'order-wizard',
    imports: [  CommonModule, ReactiveFormsModule,
                OrderWizardHeaderComponent, OrderWizardFooterComponent, 
                OrderWizardPurchaseComponent, OrderWizardPickupPointComponent,
                OrderWizardIdentificationComponent, OrderWizardDueDiligenceComponent,
                OrderWizardSummaryComponent,OrderWizardTermAndConditionComponent,
                TranslateModule],
    templateUrl: './order-wizard.component.html',
    styleUrls: ['./order-wizard.component.scss'],
    animations: []
})
export class OrderWizardComponent {
    form: FormGroup | null = null;

    constructor(
        public _orderWizardService: OrderWizardService,
        public _orderWizardNavigationService: OrderWizardNavigationService
    ) {
        this.form = this._orderWizardService.formGroup;
    }

    ngOnInit(): void {
        this._orderWizardService.init();        
    }

}
